export default __webpack_public_path__ + "static/media/waves-white.7e7579c6.svg";